import { serverUrl, getheader,setErrorDialog } from "../../../store/api/CommonFunctions";
export function attachFile(fileInput, parentID, attachmentType, fn, moreInfo, nameIsUnique) {
    if (!fileInput || !fileInput.files || fileInput.files.length === 0) {
        if(fn)
        {
            fn();
        }
        return;
    }
    var formdata = new FormData();
    for (let i = 0; i < fileInput.files.length; i++) {
        formdata.append(fileInput.files[i].name, fileInput.files[i]);
        formdata.append("ParentID", parentID);
        formdata.append("AttachmentType", attachmentType);
    }
    if (moreInfo) {
        formdata.append("moreInfo", moreInfo);
    }
    var xhr = new XMLHttpRequest();
    xhr.open('POST', serverUrl + 'api/Attachments/Upload', true);
    xhr.setRequestHeader("token", localStorage.getItem("token"));
    if (nameIsUnique) {
        xhr.setRequestHeader("NameIsUniq", nameIsUnique);
    }
    xhr.send(formdata);
    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var response = JSON.parse(xhr.responseText);
            if (response.Message !== "Error") {
                alert("بارگذاری با موفقیت انجام شد");
                if (fn)
                    fn();
            }
            else {
                alert("اشکال در آپلود فایل");
            }

        }
        return "UnExpected Error";

    };
}
export function downloadFile(itemID, attachmentType) {
   // window.open(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`, "download");
   fetch(serverUrl + `api/Attachments/DownloadAttachment?id=${itemID}&attachmentType=${attachmentType}`,
   {
     headers: {
       'Content-Type': 'blob',
       'token': localStorage.getItem("token")
     }
     , method: "get"
   })
   .then((response) => {
     response.blob()
       .then((blob) => {
         if(blob.type ==="application/json")
         {
           return;
         }
         var a = document.createElement("a");
         a.href = window.URL.createObjectURL(blob);
         a.download = "Download";
         a.click();
       })
   })   
}
export function deleteAttachment(id, type, onSuccess) {
    return dispatch => {
        fetch(serverUrl + `api/Attachments/DeleteAttachment?id=${id}&attachmentType=${type}`, {
            headers: getheader(),
            method: "GET",
            cache: "no-cache"
        }).then(res => res.json())
            .then(res => {
                if (res === "Success") {
                    setErrorDialog(dispatch, "success", "حذف پیوست");
                    if (onSuccess) {
                        onSuccess();
                    }
                }
                else {
                    setErrorDialog(dispatch, "Error", "حذف پیوست");
                    return dispatch({
                        type: "DELETE_ATTACHMENT",
                        data: "ERROR"
                    });
                }
            }).catch(e => {
                console.log("[DELETE_ATTACHMENT]", e);
            })
    }
}
export function loadDocumentTypes(onGetData) {
    onGetData("PENDING");
    fetch(serverUrl + "api/DocumentsAPI/GetDocumentTypes", {
        headers: getheader(),
        method: "GET",
        cache: "no-cache"
    }).then(res => res.json())
        .then(res => {
            if (res.Message) {
                res = [];
            }
            onGetData(res);
        }).catch(e=>{ onGetData([]); console.log("DOCUMENT_TYPES", e);})
}